<template>
  <div class="ieProductionMonitoring" ref="ieProductionMonitoring">
    <div class="ieBox">
      <div class="ieList" :style="{ top: -(nowListIndex * baseItemHeight) + 'px' }">
        <div class="ieItem" v-for="(item, index) in ieListData" :key="index">
          <div>{{ item.deviceTypeName }}</div>
          <div class="ieBar">
            <div class="ieBarBack" :style="{
                backgroundImage:backgroundImage(item.deviceTypeName,0),
              }"></div>
            <div class="ieBarValue" :style="{
                backgroundImage: backgroundImage(item.deviceTypeName,1),
                width: countWidth(item) + '%',
              }"></div>
          </div>
          <div class="ieCount">
            <div>
              总<span class="number">{{ addZero(item.totalCnt)
                }}<countToo :value="item.totalCnt"></countToo>
              </span>
            </div>
            <div>
              开<span class="number">{{ addZero(item.onlineCnt)
                }}<countToo :value="item.onlineCnt"></countToo>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countToo from "@/components/vueCountTo";
export default {
  components: { countToo },
  props: ["matrix", "x", "y"],
  data() {
    return {
      pageInfo: 'IE_productionMonitoring.vue',
      computedName: '重点设备生产监控组件',
      customerId: this.$store.state.customerId,
      ieListData: [
        {
          deviceTypeName: "高炉",
          totalCnt: 6,
          onlineCnt: 2,
        },
        {
          deviceTypeName: "转炉",
          totalCnt: 26,
          onlineCnt: 10,
        },
        {
          deviceTypeName: "竖炉",
          totalCnt: 6,
          onlineCnt: 0,
        },
        {
          deviceTypeName: "烧结机",
          totalCnt: 7,
          onlineCnt: 5,
        },
        {
          deviceTypeName: "回转窑",
          totalCnt: 7,
          onlineCnt: 7,
        },
        {
          deviceTypeName: "轧线",
          totalCnt: 6,
          onlineCnt: 2,
        },
      ],
      imgUrlList: {
        高炉: [require("./img/gaolu1.png"), require("./img/gaolu2.png")],
        转炉: [require("./img/zhuanlu1.png"), require("./img/zhuanlu2.png")],
        竖炉: [require("./img/shulu1.png"), require("./img/shulu2.png")],
        烧结机: [
          require("./img/shaojieji1.png"),
          require("./img/shaojieji2.png"),
        ],
        回转窑: [
          require("./img/huizhuanyao1.png"),
          require("./img/huizhuanyao2.png"),
        ],
        轧线: [require("./img/zhaxian1.png"), require("./img/zhaxian2.png")],
      },
      nowListIndex: 0,
      baseItemHeight: 38,
      // getlistTimer:null,
    };
  },
  computed: {
    backgroundImage() {
      return (name, i) => {
        if (this.imgUrlList[name]) {
          return "url(" + this.imgUrlList[name][i] + ")";
        } else {
          return "url(" + this.imgUrlList["高炉"][i] + ")";
        }
      };
    },
    // 计算宽度比例
    countWidth() {
      return (item) => {
        return (item.onlineCnt / item.totalCnt).toFixed(2) * 100;
      };
    },
    // 补零
    addZero() {
      return (num) => {
        return num > 9 ? "" : "0";
      };
    },
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.ieProductionMonitoring).outerWidth();
    let h = $(that.$refs.ieProductionMonitoring).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });

    this.getListData();
    // this.test();
    // this.listCarousel();
  },
  unmounted() {
    this.clearTimer(this.getlistTimer, false);
    this.clearTimer(this.listTimer);
  },
  methods: {
    // 每小时获取列表
    async getListData() {
      this.clearTimer(this.getlistTimer, false);
      let keyProduct = CONFIG.requestName + this.$apiOpt.keyProduct;
      let res = await this.$apiUtils.get(keyProduct, {
        customerId: this.customerId,
      });
      if (res) {
        this.ieListData = res;
        this.listCarousel();
      }
      this.getlistTimer = setTimeout(() => {
        this.getListData();
      }, 60 * 1000 * 30);
    },
    // 列表轮播
    listCarousel() {
      this.clearTimer(this.listTimer);
      if (this.ieListData.length > 5) {
        this.listTimer = setInterval(() => {
          if (this.nowListIndex + 5 >= this.ieListData.length) {
            this.nowListIndex = 0;
          } else {
            this.nowListIndex++;
          }
        }, 1000 * 30);
      }
    },
    // 清除定时器
    clearTimer(timer, isInterval = true) {
      if (timer) {
        isInterval ? clearInterval(timer) : clearTimeout(timer);
        timer = null;
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped="scoped">
.ieProductionMonitoring {
  height: 250px;
  width: 600px;
  .ieBox {
    width: 560px;
    height: 182px;
    margin-top: 35px;
    overflow: hidden;
    position: relative;
    .ieList {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      position: absolute;
      transition: all 1.5s;
      :not(:last-child) {
        margin-bottom: 2px;
      }
      .ieItem {
        padding: 0 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 35px;
        line-height: 35px;
        > :first-child {
          width: 60px;
          color: rgba(159, 209, 221, 1);
        }
        .ieBar {
          width: 346px;
          height: 35px;
          position: relative;
          > div {
            height: 100%;
            background-repeat: no-repeat;
            position: absolute;
            left: 0;
            background-position-y: center;
          }
          .ieBarBack {
            width: 100%;
          }
          .ieBarValue {
            transition: width 1.5s;
          }
        }
        .ieCount {
          width: 120px;
          height: 35px;
          display: flex;
          justify-content: space-between;
          background: rgba(0, 22, 74, 1);
          margin-left: 4px;
          > div {
            width: 50%;
            display: flex;
            justify-content: space-between;
            padding: 0 6px;
          }
          span {
            font-size: 24px;
          }
          :nth-child(1) span {
            color: rgba(244, 196, 143, 1);
          }
          :nth-child(2) span {
            color: rgba(71, 255, 221, 1);
          }
        }
      }
    }
  }
}
</style>
